import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  HostBinding,
  Input,
  OnInit,
  Optional,
} from '@angular/core';
import { AbstractControl, ControlValueAccessor, FormControl, FormGroupDirective, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CheckboxComponent } from './checkbox.component';

@Component({
  selector: 'mtg-checkbox-group',
  templateUrl: './checkbox-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CheckboxGroupComponent),
      multi: true
    }
  ],
})
export class CheckboxGroupComponent implements OnInit, ControlValueAccessor {
  private onTouch: () => void;
  private onChange: (value) => void;
  private control: AbstractControl;
  @Input()
  formControl: FormControl;
  @Input()
  formControlName: string;
  @Input()
  reverse: boolean;
  value: any[] = [];
  checkboxes: CheckboxComponent[] = [];

  @HostBinding('class.checkbox-group')
  get defaultClass() {
    return true;
  }

  constructor(
    @Optional() private parentFormGroup: FormGroupDirective,
  ) {
  }

  ngOnInit(): void {
    if (this.parentFormGroup) {
      this.control = this.formControl || this.parentFormGroup.control.get(this.formControlName);
    } else {
      this.control = this.formControl;
    }
  }

  addCheckbox(checkbox: CheckboxComponent): void {
    this.checkboxes.push(checkbox);
  }

  removeCheckbox(checkbox: CheckboxComponent): void {
    if (this.checkboxes.indexOf(checkbox) > -1) {
      this.checkboxes.splice(this.checkboxes.indexOf(checkbox), 1);
    }
  }

  writeValue(obj: any): void {
    this.value = obj || [];
    for (const checkbox of this.checkboxes) {
      if (this.value.indexOf(checkbox.value) > -1) {
        checkbox.changeValue(true, true);
      } else {
        checkbox.changeValue(false, true);
      }
    }
  }

  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  onItemChanged(value: any, checked: boolean): void {
    if (checked) {
      if (this.value.indexOf(value) < 0) {
        this.value.push(value);
      }
    } else if (this.value.indexOf(value) > -1) {
      this.value.splice(this.value.indexOf(value), 1);
    }
    if (this.onTouch) {
      this.onTouch();
    }
    if (this.onChange) {
      this.onChange(this.value);
    }
  }
}
